<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-ph-download-report-contracts">

    <page-title :title="'Pobierz raport umów'" :back="true"></page-title>

    <slide-y-up-transition :duration="400" :delay="300">
      <p v-if="show" class="text-center">Czekaj... pobieranie raportu umów rozpoczęło się.</p>
    </slide-y-up-transition>

    <slide-y-up-transition :duration="400" :delay="300">
      <div v-if="success" class="text-center">
        <p>Raport umów został pobrany do pliku.</p>
      </div>
    </slide-y-up-transition>

    <slide-y-up-transition :duration="400" :delay="400">
      <div v-if="success" class="text-center">
        <ion-button mode="ios"
                    fill="outline"
                    size="normal"
                    @click="getFile">Ponów pobieranie
        </ion-button>
      </div>
    </slide-y-up-transition>

  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import PageTitle from '@/components/PageTitle.vue';
  import router from "../../router";
  import Save from '@/services/Save';

  export default {
    name: 'PhDownloadReportContracts',
    components: { PageTitle },
    data(){
      return {
        show: false,
        success: false
      }
    },
    computed: {
      ...mapGetters('profile', ['getProfile']),
      ...mapState({
        errors: state => state.clients.errors,
        loading: state => state.clients.loading,
      })
    },
    mounted(){
      this.show = true
      this.getFile()
    },
    methods: {
      getFile(){
        let payload = {'ph_slug' : this.getProfile.slug};
        this.$store.dispatch('clients/PH_REPORT_CONTRACTS_REQUEST', payload).then((resp) => {
          this.show = false
          Save.file(resp, "raport.xlsx", {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
          //
          setTimeout(() => {
            this.success = true
          },500)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  ion-card-content{
    padding: 8px 12px;
  }
  ion-card-header{
    --background: #ffffff;
  }
</style>